<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						보낸 전자우편
						<small class="text-nomal m-l-10">보내는 사람 : {{config.item.mberName || '이름 없음'}} &lt;{{config.item.mberId || '아이디 없음'}}&gt; {{config.item.mberEmail || '전자우편 주소 없음'}}</small>
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
					</div>
				</div>
				<div class="modal-body  p-10 clearfix" style="min-height: 1px;">
					<div class="send-box left">
						<h3 class="send-tit"><span>받는사람</span></h3>
						<ul class="item-list">
							
							<li v-for="item in recvList" :key="'recvItem-'+item.emailRecvId">
								<span class="name">
									{{item.recvName || '이름 없음'}}</span><span class="info">{{item.recvEmail}}</span>
							</li>
						</ul>
					</div>
					<div class="send-box right">
						<h3 class="send-tit"><span>보낸 전자우편함</span></h3>
						<div class="send-box full-width">
							<input type="text" class="form-control full-width m-b-10 round text-left"
								:value="title" disabled>
							<div  v-for="(item, idx) in atchList" class="input-group on-border round full-width m-b-10" :key="'atchList'+idx">
								<span class="input-group-addon v-mid w40">
									<a :href="parseHref(item.atchFileId)" target="_blank">
										<svg xmlns="http://www.w3.org/2000/svg" class="v-mid" width="22" height="18" viewBox="0 0 53 49">
											<path class="down-on"
												d="M56.482,23.889A1.51,1.51,0,0,0,54.963,25.4V39.182a6.806,6.806,0,0,1-6.8,6.788H14.842a6.806,6.806,0,0,1-6.8-6.788v-14a1.518,1.518,0,0,0-3.037,0v14A9.841,9.841,0,0,0,14.842,49H48.158A9.841,9.841,0,0,0,58,39.182V25.4A1.517,1.517,0,0,0,56.482,23.889ZM30.432,36.972a1.53,1.53,0,0,0,1.069.449,1.484,1.484,0,0,0,1.069-.449l9.651-9.627A1.517,1.517,0,0,0,40.071,25.2l-7.053,7.046V1.515a1.518,1.518,0,0,0-3.037,0V32.248L22.918,25.2a1.517,1.517,0,1,0-2.148,2.143Z"
												transform="translate(-5)" />
										</svg>
									</a>
								</span>
								<span class="input-group-addon text-left">
									{{item.atchFileName || '파일명 없음'}}
								</span>
							</div>
							<!-- //end .send-search-box -->
						</div>
						
						<div class="text-edit on-border round p-15" v-html="content" >
						</div>
						<p class="m-b-0">
							<span>보낸일시 : {{parseSendDate()}}</span>
						</p>
					</div>
				</div>

				<div class="modal-footer p-15 m-t-30 clearfix">
					<button 
						class="btn full-width bg-deepblue text-white round m-r-5" 
						type="button"
						@click="$emit('close')"
					>확인</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import server from '../statics/server'// eslint-disable-line no-unused-vars

import _ from 'lodash'// eslint-disable-line no-unused-vars
import moment from 'moment'// eslint-disable-line no-unused-vars

export default {
	name:"ModalEmailSentDetail",

	default: function(){
		return {
			name: this.name,
			show: false,

			item : ''
		}
	},

	props: {
		config: Object
	},

	data (){
		return {
			modify_mode : false,
			
			title : this.config.item.title,
			content : this.config.item.content,
		}
	},
	computed : {
		atchList(){
			return this.config.item.emailAtchList;
		},
		recvList(){
			return this.config.item.emailRecvList;
		},
	},
	filters : {
		
	},
	methods: {
		modifyEmailForm(){
			const self = this;
			let item = {
				emailTemplId : this.config.item.emailTemplId,
				title : this.title,
				content : this.content,
			}


			server.patchAxios('sys/emailTempl', item.emailTemplId, item,({data, err}) => {
				err; data;
				self.$emit('refresh');
				self.modify_mode = !self.modify_mode;
			});
		},

		parseSendDate(){
			if(this.config.item['sendDate'] === undefined){
				return this.config.item.state;
			}else{
				return moment(this.config.item['sendDate']).format('YYYY년 MM월 DD일 HH:mm:ss') + '(' + this.config.item.state + ')'
			}
		},
		parseHref(file_id){
			return server.addr() + '/download/' + file_id;
		}
	},
}
</script>

<style scoped>
.down-on {
	fill: #999;
	fill-rule: evenodd;
}
a:hover .down-on {
	fill: #156ea2;
	fill-rule: evenodd;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.down-on {
	fill: #999;
	fill-rule: evenodd;
}

	a:hover .down-on {
	fill: #156ea2;
	fill-rule: evenodd;
}
</style>